module.exports = __webpack_public_path__ + "static/media/tablet_frs.5f5bdd44.png";